module.exports = __webpack_public_path__ + "h5/img/rushBuyBg.12697b84.jpg";